import * as s from '@/stores'
import { type StoreCache } from '@/composables/useStoreCache.ts'

interface StoreWithFindAll<T> {
  findAll: (criteria: T, bypassCache?: boolean) => unknown
  $reset: () => void
  $cache: StoreCache
}

interface PreloadStoreDef {
  store: StoreWithFindAll<unknown>
  criteria: unknown
}

function definePreloadStore<T extends StoreWithFindAll<Parameters<T['findAll']>[0]>>(store: T, criteria: Parameters<T['findAll']>[0] = null): PreloadStoreDef {
  return {
    store: store,
    criteria: criteria
  }
}

export async function afterLoginSuccess() {
  const storesToPreload: PreloadStoreDef[] = [
    // definePreloadStore(s.useGeneratedEmployeeConfigStore()),
    // definePreloadStore(s.useGeneratedConfigStore()),
    definePreloadStore(s.useGeneratedEffortTypeStore()),
    definePreloadStore(s.useGeneratedDepartmentStore()),
    definePreloadStore(s.useGeneratedRoleStore()),
    definePreloadStore(s.useGeneratedExpenseTypeStore()),
    definePreloadStore(s.useGeneratedServiceTypeStore())
    //definePreloadStore(s.useGeneratedEmployeeStore(), { query: { 'order[firstname]': 'asc', hidden: false } })
  ]
  // storesToPreload.forEach((value) => void value.store.$reset())
  //const preloadPromises: Promise<unknown>[] = []
  for (const preloadStoreDef of storesToPreload) {
    if (!preloadStoreDef.store.$cache) return
    await preloadStoreDef.store.$cache.cleanExpired()
    const hasData = await preloadStoreDef.store.$cache.hasData()
    if (hasData) return
    try {
      const x = (await preloadStoreDef.store.findAll(preloadStoreDef.criteria ?? {})) as Promise<unknown>
    } catch (_e) {
    }
    //preloadPromises.push(promise)
  }
  //debugger
}
